import { filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';

import {
  getResourceList,
  getListDetail,
  deleteResourceList,
  deleteListDetail
} from 'api/customList';

type customListState = {
  isLoading: boolean;
  error: boolean;
  resourceList: [];
  folderList: [];
};

const initialState: customListState = {
  isLoading: false,
  error: false,
  resourceList: [],
  folderList: []
};

const slice = createSlice({
  name: 'customList',
  initialState,
  reducers: {
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    //
    getResourceList(state, action) {
      state.isLoading = true;
      state.resourceList = action.payload;
    },
    // 通过id获取课件详情
    getListDetail(state, action) {
      state.isLoading = true;
      state.folderList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
// 获取列表，文件夹里面的资料
export function getResourceListAction(params: any) {
  return async (dispatch: any) => {
    try {
      const res = await getResourceList(params);
      dispatch(slice.actions.getResourceList(res.rows));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取列表详情
export function getListDetailAction(params: any) {
  return async (dispatch: any) => {
    try {
      const res = await getListDetail(params);
      dispatch(slice.actions.getListDetail(res.rows));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 删除列表
export function deleteListAction(params: any) {
  return async (dispatch: any) => {
    try {
      const res = await deleteResourceList(params);
      console.log(' delete res', res);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 删除列表详情课件
export function deleteListDetailAction(params: any) {
  return async (dispatch: any) => {
    try {
      const res = await deleteListDetail(params);
      console.log(' delete DETAIL res', res);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
